import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const quaoarChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -6934880224.4269543, 306089318.09666586, 2793065.5016163508, -27619.223260402679, -9110.0000866095215, 437.33119427363079, -512.89065639177954, 164.62868418693543,
      -157.64335082372028, -150.68467473983765, 507.65009654362996, 1.3938534259796143,
    ]),
    new Float64Array([
      -10657155788.935394, -172332842.84074557, 3894542.5354935643, 75204.592312018081, 412.6245678583781, -619.08729921976726, 93.016393534342441, -6.7785629272460932,
      115.71068210601807, 83.914470958709714, -151.47974440256755, -75.324602127075195,
    ]),
    new Float64Array([
      -3119476687.2792277, -41174271.226081237, 1130495.6524602652, 27807.157960096996, 559.85900150934856, -379.78936305046079, 66.950068815549216, -169.73236234982809,
      -68.066993459065756, 205.73609875043232, -50.962217815717061, -166.05001791318259,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -5670595260.0319061, 325265518.18319094, 1875666.402939399, -89175.64854920705, 6579.8284920056658, 2217.7332773367561, -551.63700855573018, 19.115628083546955,
      -323.745578511556, -152.04969914754233, 600.72590120633447, 61.954198757807411,
    ]),
    new Float64Array([
      -11279727137.846621, -138531424.73762035, 4377655.4345589634, -23925.346159998575, -9684.0208283742268, 919.54413420359288, 120.0007817586263, 139.70880845387777,
      -16.040186977386476, -18.11826597849528, 132.68773832321168, -72.552183787028,
    ]),
    new Float64Array([
      -3264463429.8845158, -31170427.35762573, 1298208.4712735573, -13021.132514270146, -4016.1646474917729, 174.03799538612367, 182.51765525341034, -96.250704971949261,
      -269.32580974896746, 85.937300109863287, 108.70327976544698, 23.027044598261515,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -4342196902.5984726, 338855028.31926376, 1740924.2414293925, 17977.473007313409, -7528.6436834017431, -884.39717823664341, -278.00533563296, -109.67358571688334,
      -403.55843504269916, 127.81461747487386, 693.580073595047, -32.357085943222046,
    ]),
    new Float64Array([
      -11766208749.127443, -104917493.50521329, 4173399.7748898505, 45012.808122444156, 7759.5175183931988, -772.62230319976811, -29.658608404795327, -189.75536060333252,
      40.152352714538573, -69.541426277160639, 21.037356440226237, 87.376189422607425,
    ]),
    new Float64Array([
      -3369712236.6881857, -21589110.497435577, 1156168.2988531906, 14135.292609230677, 3822.462220708529, -332.77612469196322, 116.81010704040527, -6.3138742605845133,
      -193.96742770671844, -84.133951481183374, 110.4957530260086, 65.649145499865213,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -2960573604.4346757, 351506374.89682502, 1205366.9827578384, -100768.38311854999, -5153.4014651298521, 687.37873294353483, -315.10798443953195, 29.014609193801878,
      -323.2102025826772, 70.742387843132022, 555.50009160836532, -31.453703959782917,
    ]),
    new Float64Array([
      -12114608942.502075, -68690833.68563804, 4854402.4735516869, 29926.639332866667, -8517.1732593536381, -765.86449499130254, 305.80440889994304, -34.869371064503987,
      64.304217179616288, 14.366977341969807, -218.82968597412108, 28.643555545806883,
    ]),
    new Float64Array([
      -3435945158.1551981, -11306796.376082968, 1408406.6502109608, 11057.637977735201, -3334.5822467724483, -282.71762825647988, 219.12738582293193, 177.97459355195363,
      -169.05957868099213, -153.30130490461985, -4.5003035386403401, 89.781741356849665,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      -1541832159.1232047, 357209217.78827941, 452330.79750628473, 14460.821376943588, 5332.855908036232, -2465.3498125394185, -865.89066771666205, 147.55402589639027,
      -257.96258211135864, -3.9577741940816242, 612.84429078896835, 25.038793190320334,
    ]),
    new Float64Array([
      -12312650955.428129, -30629291.114545662, 4542771.541987991, -23302.541338189443, 10960.578935782114, 565.16263656616206, -205.91449794769287, -72.472020371754965,
      -94.867266464233396, 181.70669685999553, -56.473899682362877, -149.06367788314819,
    ]),
    new Float64Array([
      -3459181121.0905619, -461822.23151344457, 1247538.8977165937, -13921.421709259352, 4465.9976165533062, 370.27145053545632, -78.052629812558493, 207.36593430042265,
      0.07603882948557536, -118.60188302199046, 28.128508305549619, 46.560781049728391,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      -105491449.53284255, 360835444.72874618, 280686.32384816604, -71505.161883495253, -8020.5623030543329, 126.22535173296929, -981.14165391723316, -292.54642184376718,
      -269.44978664716086, 155.37324595451355, 757.33755019903185, 76.497269006570178,
    ]),
    new Float64Array([
      -12360948191.06226, 6856901.6983869867, 4960212.9494144125, 50876.063030942278, -3205.1914459228515, -932.67255605061848, -58.286622524261475, 25.379076131184895,
      -66.847180716196689, 32.626166852315265, 140.61104847590127, 20.967505772908527,
    ]),
    new Float64Array([
      -3440658478.4712591, 9855978.8659830242, 1393365.848008736, 20707.297850577037, -1428.5948620557785, -165.42023046811423, -45.86933234532674, 271.30392388502759,
      145.33671210606892, -143.10864748954774, -14.266512346267699, -69.017368078231812,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      1335184005.6598599, 358523916.90716672, -845845.97170351143, -55885.883028946322, 13385.785867532095, 507.53129200538001, -1187.229935558637, -144.61806708176931,
      -136.51514281829199, 88.054606445630384, 536.80291816194847, 22.639889951546987,
    ]),
    new Float64Array([
      -12252829187.064489, 47138335.420915321, 4876991.0649258615, -69401.073973401391, -1741.8732069333394, 2180.273999118805, 128.6258188565572, -158.64342231750487,
      -100.69566090901692, -56.188254674275719, 23.434162425994874, 96.150412782033285,
    ]),
    new Float64Array([
      -3378383468.5327859, 21254022.351347819, 1356897.5570590019, -30441.203504991532, -1305.3179117202758, 976.72879611651103, -42.988064893086751, -34.028285312652585,
      166.55425403912861, -28.019689639409382, -133.25619421799976, 25.689794596036275,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      2754935613.971652, 351357329.78976053, -896057.93955325685, -22403.221294760704, -8996.1717541138332, 369.84096655050911, -807.15402373870211, -39.283072924613954,
      -13.51169542868932, -99.687036808331811, 540.96285113096235, 64.363013478120166,
    ]),
    new Float64Array([
      -11989348610.54421, 84429041.296254158, 4670848.3781037964, 39202.81684090296, 2481.0869938214619, -947.40001811981199, 126.97540203730266, 203.32057247161865,
      -11.357282861073811, -123.83530969619751, -125.62748305002849, 45.030380121866862,
    ]),
    new Float64Array([
      -3273095495.5605183, 31300149.92705017, 1250896.0441497166, 16289.961774953206, 1152.2577521880467, -483.38358413378398, -59.965392080942792, -82.226489424705505,
      231.58907870451608, 71.204919091860447, -165.20008153120676, -8.5427712837855019,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      4141547984.325469, 341172217.73007959, -1809717.5633787473, -105537.35993561744, 2395.1812413056691, 2147.98084534804, -709.66949507395429, -152.36249273618063,
      -325.3166749080022, -76.579909515380862, 771.3361739635468, 144.32299464543661,
    ]),
    new Float64Array([
      -11574519328.27153, 123183646.39766203, 4882821.4650227865, -37387.796173254646, -10364.122699928284, 199.08524754842122, 216.96590582529703, 90.903168932596842,
      48.655215295155841, 30.382643381754558, -32.641527207692462, -102.2810541788737,
    ]),
    new Float64Array([
      -3126820824.1903763, 41933322.824347466, 1354691.6610540629, -13607.185292593638, -4462.423302149773, -49.147842375437421, -13.538750314712525, -219.81881380081177,
      81.97510826587677, 159.74130105177562, -84.727142246564227, -76.651111181577051,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      5472798451.3405294, 324157799.01864815, -2182539.9728301684, 20248.849900754292, -4881.7909490744269, -1431.2978882789612, -425.04581306775412, 76.255593617757157,
      -428.30005758603414, 7.3423229217529293, 756.85327665011084, -46.548840188980101,
    ]),
    new Float64Array([
      -11008282117.281958, 159340884.02242711, 4226249.1026751837, -4858.7646150906876, 9986.4034282684333, -746.775938574473, -245.79925003051758, 256.6264860788981,
      -28.151233641306558, -153.75101143519083, 56.499142710367835, 14.096098581949869,
    ]),
    new Float64Array([
      -2939296693.1118488, 51582207.872558028, 1082960.6744940518, -1980.1990283091864, 4566.6098473866778, -505.79576787153877, -109.00933161576589, -240.57399051984152,
      -86.519601869583127, 144.97162037690481, 75.239789724349976, 84.06193668842316,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      6733403224.212369, 305773739.84943926, -2627522.9879363379, -95456.26572295824, -6654.3186578273771, 505.14669432640073, -643.6565084616343, 50.217622931798296,
      -280.04197533925372, -56.198363669713338, 727.81427408854165, 102.13682664235432,
    ]),
    new Float64Array([
      -10301849315.507086, 194113180.90339541, 4480383.6568513233, 5841.2466008186339, -7069.4060782432553, -516.1337129592896, 66.923274644215894, -96.724506028493238,
      63.423324648539221, -114.80659313201905, -75.600965817769364, 158.77379706700643,
    ]),
    new Float64Array([
      -2714932272.480999, 60721387.055189259, 1214820.0051722128, 6368.3715605417883, -2570.3571630557376, -238.23318731784821, 63.98595666885376, -105.78239305814107,
      -121.54118021329244, 19.258790381749471, 102.38777601718903, -11.303966927528382,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      7797253130.9109516, 226630781.84460971, -2262607.3754309812, -7976.054503186544, 4881.1363672733305, -409.71636937459311, -1086.5660533110301, 94.028708871205652,
      311.60182102521259, 42.859476884206138, 1225.3521716276805, -42.024437332153319,
    ]),
    new Float64Array([
      -9549761716.073431, 179987850.01744914, 2486222.2885969481, -48271.901550801595, 2132.5415702501932, 818.8811576207479, -14.08847557703654, -141.87040179570516,
      -113.64219856262207, 26.861648114522296, 21.036391989390054, -1.3419004122416178,
    ]),
    new Float64Array([
      -2481937201.495028, 55219248.232395142, 641464.80297545588, -19508.711625154814, 817.64976522922518, 136.76276486714681, -188.29227358500162, 188.23114019234976,
      19.881286867459615, -91.334177533785507, 28.492285839716594, 24.260072716077168,
    ])
  ),
];
